import getConfig from "next/config";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useTestDriveTypesSelector } from "@redux/reducers/appConfig";
import {
  TEST_DRIVE_POINT_STORE_TYPE,
  TEST_DRIVE_TYPE_ID,
} from "@shared/constants";

const { publicRuntimeConfig } = getConfig();

const { DEAL_API_URL } = publicRuntimeConfig;

export const useGetTestDrivePointImage = () => {
  const testDriveTypes = useTestDriveTypesSelector();

  return (testDriveTypeId, storeType) => {
    const targetType = testDriveTypes.find(
      testDriveType => testDriveType.id === testDriveTypeId
    );

    if (testDriveTypeId === TEST_DRIVE_TYPE_ID.SUPER) {
      return getStaticAssetURL("/images/testDrive/ami_super_fan_logo.png");
    }

    if (testDriveTypeId === TEST_DRIVE_TYPE_ID.MEDIAMARKT) {
      return getStaticAssetURL("/images/testDrive/ami_mediamarkt_logo.png");
    }

    switch (storeType) {
      case TEST_DRIVE_POINT_STORE_TYPE.DARTY:
        return getStaticAssetURL("/images/testDrive/dartyLogo.png");

      case TEST_DRIVE_POINT_STORE_TYPE.FNAC:
        return getStaticAssetURL("/images/testDrive/fnacLogo.png");

      case TEST_DRIVE_POINT_STORE_TYPE.HOME:
        return getStaticAssetURL("/images/testDrive/homeDelivery.svg");

      case TEST_DRIVE_POINT_STORE_TYPE.F2M:
        return `${DEAL_API_URL}/svg/logo.svg?color=FC178E`;

      default:
        return targetType
          ? `${DEAL_API_URL}/svg/logo.svg?color=${targetType.colorHexa}`
          : null;
    }
  };
};
